import { NgModule } from "@angular/core";
import { BnComparacaoABDirective } from "../directives/bn-comparacao";

@NgModule({
    declarations: [BnComparacaoABDirective],
    exports: [BnComparacaoABDirective]
})
export class BnComparacaoABModule { }